var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","top":"0","width":"100%","height":"100%","background":"rgba(1,1,1,0.5)","z-index":"9999999"},style:({display:_vm.show?'block':'none'}),on:{"click":function($event){return _vm.$emit('clicked')}}})}
var staticRenderFns = []

export { render, staticRenderFns }